import { render } from "./CadastrarPatologia.vue?vue&type=template&id=8cf808fa&scoped=true"
import script from "./CadastrarPatologia.vue?vue&type=script&lang=js"
export * from "./CadastrarPatologia.vue?vue&type=script&lang=js"

import "./CadastrarPatologia.vue?vue&type=style&index=0&id=8cf808fa&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf808fa"]])

export default __exports__